import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["ref", "as"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.bold.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import styled, { css } from 'styled-components';
import { getPropFilter, getPropNamesFromPropDefinition, getDimmedTextColor } from 'utils/ui';
import { positionProps, positionPropsDef, marginProps, marginPropsDef } from 'styles/styleProps';
import ButtonCore from 'components/ButtonCore';
import { jsx as _jsx } from "react/jsx-runtime";
function getLinkColor(_ref) {
  var stealthy = _ref.stealthy,
    disabled = _ref.disabled,
    isDisabled = _ref.isDisabled,
    theme = _ref.theme;
  if (disabled || isDisabled) {
    return getDimmedTextColor(theme);
  } else if (stealthy) {
    return 'inherit';
  } else {
    return theme.links;
  }
}
var stylePropNames = getPropNamesFromPropDefinition([].concat(_toConsumableArray(positionPropsDef), _toConsumableArray(marginPropsDef)));
var textLinkProps = ['bold', 'stealthy', 'fontSize', 'iconRight', 'iconOnly'];
var shouldForwardProp = getPropFilter([].concat(textLinkProps, _toConsumableArray(stylePropNames)));
var textLinkStyles = css(["", " ", " text-align:inherit;text-decoration:none;transition:color 0.25s ease-in;color:", ";&:not(.is-disabled):hover,&:not(.is-disabled):focus,&:not(.is-disabled):active{", " text-decoration:underline;transition-timing-function:ease-out;}"], function (p) {
  return p.fontSize && "\n\t\tfont-size: ".concat(p.theme.globals.typeScale[p.fontSize] || p.fontSize, ";\n\t");
}, function (p) {
  return p.bold && "\n\t\tfont-weight: bold;\n\t";
}, getLinkColor, function (p) {
  return p.stealthy && "\n\t\t\tcolor: ".concat(p.theme.links, ";\n\t\t");
});
var Wrapper = styled(ButtonCore).withConfig({
  shouldForwardProp: shouldForwardProp
}).withConfig({
  displayName: "TextLink__Wrapper",
  componentId: "sc-9hqv98-0"
})(["", " display:inline;vertical-align:baseline;", " ", ""], positionProps, marginProps, textLinkStyles);
export var TextLink = function TextLink(_ref2) {
  var ref = _ref2.ref,
    as = _ref2.as,
    otherProps = _objectWithoutProperties(_ref2, _excluded);
  var Component = as || 'a';
  return /*#__PURE__*/_jsx(Wrapper, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    forwardedAs: Component
  }));
};
TextLink.displayName = 'TextLink';

// Allow components to re-use simple text link styles
export { textLinkStyles, textLinkProps };
export default TextLink;